// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3c0206be","925":"228957c6"}[chunkId] + ".chunk.js";
};